import { useLocation } from "@/views/postalNewCustomer/useLocation";
import { Popup } from "vant";
import { mapState } from "vuex";

export default function(cityName) {
  return {
    components: {
      Popup
    },
    data() {
      return {
        visible: false,//是否显示弹窗
        isPower:true,//是否有定位权限
      };
    },
    computed: {
      ...mapState({
        system: state => state.app.system
      })
    },
    async created() {
      window.getLocationCallback = result => {
        if (typeof result === "string") {
          result = JSON.parse(result);
        }
        console.log(result, typeof result);
        if (result.optState || result.result === "01") {
          if (result.cityName !== cityName) {
            this.visible = true;
          }
        } else {
          this.getLocationByH5();
        }
      };

      const loading = this.$toast.loading({
        forbidClick: true,
        message: "加载中..."
      });
      await this.getLocation();
      loading.close();

      console.log(this.$createElement);
    },
    methods: {
      async getLocation() {
        if (this.system === "ios") {
          const getLocationMethod =
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.QTX_H5_LOCATION;
          if (getLocationMethod) {
            getLocationMethod.postMessage({
              callBack: "getLocationCallback",
              reGeocode: "1"
            });
          } else {
            await this.getLocationByH5();
          }
        } else if (this.system === "android") {
          try {
            await window.CarbonWebView.getLocation(true, "getLocationCallback");
          } catch (e) {
            await this.getLocationByH5();
          }
        } else {
          await this.getLocationByH5();
        }
      },
      async getLocationByH5() {
        try {
          const { city } = await useLocation();
          this.isPower = true
          if (city !== cityName) {
            this.visible = true;
          }
        } catch (error) {
          console.log('未开启定位功能')
          this.isPower = false
          this.visible = true
        }
        
      }
    },
    render(h) {
      const { visible } = this;

      return (
        <van-popup
          value={visible}
          style={{ background: "transparent", width: "100%" }}
          close-on-click-overlay={false}
        >
          <div style={{position:'relative'}}>
          <img
            style={{ width: "100%",height: "auto",display: "block"}}
            src={require("../../assets/images/postalNewCustomer/location-image.png")}
          />
          <div style={{position:'absolute',top:'38.133vw',right:0,left:0,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'3.733vw',color:'#898989'}}>
            {
            this.isPower?
            (<div style={{textAlign:'center',lineHeight:'5.333vw'}}>该活动仅限<br/>青岛地区用户参与</div>)
            :(<div style={{textAlign:'center',lineHeight:'5.333vw'}}>该活动仅限青岛地区用户参与，请打开<br/>地理位置权限获取参与资格</div>)}
          </div>
          </div>
        </van-popup>
      );
    }
  };
}
